import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

const BASE = "https://connected-center-basra.aglowspark17.chatgpt.site";

const ITEMS = [
  {
    id: "svc-1",
    num: "01",
    image: `${BASE}/latest/03.webp`,
    span: "col-span-12 lg:col-span-8 lg:row-span-2",
  },
  {
    id: "svc-2",
    num: "02",
    image: `${BASE}/latest/07.webp`,
    span: "col-span-12 md:col-span-6 lg:col-span-4",
  },
  {
    id: "svc-3",
    num: "03",
    image: `${BASE}/latest/05.webp`,
    span: "col-span-12 md:col-span-6 lg:col-span-4",
  },
  {
    id: "svc-4",
    num: "04",
    image: `${BASE}/latest/09.webp`,
    span: "col-span-12",
  },
];

export default function Services() {
  const { t } = useLang();
  return (
    <section id="services" data-testid="services-section" className="relative py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-3xl">
          <p className="mb-3 flex items-center gap-3 text-xs font-bold tracking-[0.25em] text-[#E3AF4F]">
            <span className="h-px w-10 bg-[#E3AF4F]" />
            {t.services.eyebrow}
          </p>
          <h2 className="font-heading text-2xl font-bold leading-snug text-[#F5F2EB] sm:text-3xl lg:text-4xl">
            {t.services.headingA} <span className="text-gold-grad">{t.services.headingB}</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-12 gap-5 lg:auto-rows-[270px]">
          {ITEMS.map((item, i) => {
            const text = t.services.items[i];
            return (
              <Reveal key={item.id} delay={i * 0.08} className={`${item.span} h-full`}>
                <article
                  data-testid={`service-bento-card-${item.id}`}
                  className="group relative h-full min-h-[280px] overflow-hidden rounded-3xl border border-[#F5F2EB]/10 transition-all duration-500 hover:-translate-y-1 hover:border-[#E3AF4F]/50 hover:shadow-2xl hover:shadow-[#E3AF4F]/10"
                >
                  <img
                    src={item.image}
                    alt={text.title}
                    loading="lazy"
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#000000] via-[#000000]/40 to-transparent" />
                  {text.tag && (
                    <span className="absolute start-5 top-5 rounded-full bg-[#E3AF4F] px-4 py-1.5 text-xs font-bold text-[#000000]">
                      {text.tag}
                    </span>
                  )}
                  <span className="absolute end-6 top-5 font-heading text-sm font-bold tracking-widest text-[#F5F2EB]/50">
                    {item.num} / CC
                  </span>
                  <div className="absolute inset-x-0 bottom-0 p-6 lg:p-8">
                    <span className="mb-3 inline-block rounded-full border border-[#E3AF4F]/40 bg-[#000000]/60 px-3 py-1 text-[11px] font-semibold tracking-wider text-[#E3AF4F] backdrop-blur">
                      {text.category}
                    </span>
                    <h3 className="font-heading text-xl font-bold text-white sm:text-2xl">
                      {text.title}
                    </h3>
                    <p className="mt-2 max-w-xl text-sm leading-relaxed text-[#F5F2EB]/70">
                      {text.description}
                    </p>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
